




































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import {
 SftpTestFile
} from "@/admin/types";

import Input from "@/shared/components/ui/Input.vue";
import Button from "@/shared/components/ui/Button.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import { useSftpTestFilesStore } from "@/admin/store/sftpTestFiles";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { UserPermission } from "@/shared/types";

@Component({
  components: {
    Button,
    Input,
    ErrorSummary
  }
})
export default class AdminSftpTestFiles extends Vue {

  sftpTestFilesStore = useSftpTestFilesStore();
  rolePermissionsStore = useRolePermissionsStore();

  mounted () {
    this.sftpTestFilesStore.load();
  }

  onLinkClick (file: SftpTestFile) {
    this.sftpTestFilesStore.download(file);
  }
  get hasEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilitySftpTestFileEdit);
  }
}
